import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import {Provider} from 'react-redux';
import Routes from "./Router/Router";
import * as Sentry from "@sentry/react";
import SentryManager from "../src/monitoring/Sentry";
import {store, history} from './utils/store'
import { ErrorPage } from "./shared/components/errors/ErrorPage";

SentryManager.initializeSentry();

ReactDOM.render(
    <Provider store={store}>
        <Sentry.ErrorBoundary fallback={<ErrorPage/>}>
            <Routes history={history}/>
        </Sentry.ErrorBoundary>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js